/**
 * Unsubscribe Page
 * Allows users to unsubscribe from email notifications using a token
 */

import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { unsubscribeEmail } from '../services/emailApi';
import styles from './UnsubscribePage.module.css';

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('退訂連結無效，缺少 token 參數。');
      return;
    }

    const handleUnsubscribe = async () => {
      try {
        const result = await unsubscribeEmail(token);
        if (result.success) {
          setStatus('success');
          setMessage('您已成功退訂所有 Email 通知。');
        } else {
          setStatus('error');
          setMessage(result.error?.message || '退訂失敗，請聯繫客服。');
        }
      } catch (err) {
        setStatus('error');
        setMessage('退訂失敗，連結可能已過期。');
      }
    };

    handleUnsubscribe();
  }, [token]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {status === 'loading' && (
          <>
            <div className={styles.spinner}></div>
            <h1 className={styles.title}>處理中...</h1>
            <p className={styles.message}>正在處理您的退訂請求</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className={styles.icon}>{'✅'}</div>
            <h1 className={styles.title}>退訂成功</h1>
            <p className={styles.message}>{message}</p>
            <p className={styles.info}>
              您將不再收到任何 Email 通知。如果想要重新啟用通知，請前往會員中心修改通知偏好設定。
            </p>
            <button
              className={styles.button}
              onClick={() => navigate('/member')}
            >
              前往會員中心
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className={styles.icon}>{'⚠️'}</div>
            <h1 className={styles.title}>退訂失敗</h1>
            <p className={styles.message}>{message}</p>
            <div className={styles.actions}>
              <button
                className={styles.button}
                onClick={() => navigate('/member?tab=settings')}
              >
                修改通知偏好
              </button>
              <button
                className={styles.buttonSecondary}
                onClick={() => navigate('/')}
              >
                返回首頁
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
